/**
 * mega-menu.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_back_to_top = {
    attach: function (context, settings) {

      once('saipem-back-to-top', '.back-to-top', context).forEach(
        function (element) {
            $(window).scroll(function(){
                if ($(window).scrollTop() >= 200) {
                     $('.back-to-top').show();
                }else
                {
                    $('.back-to-top').hide();
                }
            });

             $(element).click(
                function(){
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                  });

             }
          );

      }
  }
})(jQuery, Drupal, drupalSettings);
